/*
 * Project: BookingEngine
 * Module: Session.js
 */

const notLoggedInUser = () => ({ isAnonymous: true, role: '' });

const initialState = {
  showAlertMobileLandscape: false,
  isCreatingBooking: false,
  theme: null,
  user: notLoggedInUser(),
  chainData: null,
  callCenterCustomerCode: null,
  openReservationDetails: false,
};

// eslint-disable-next-line default-param-last
export const session = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION_SET_ALERTMOBILELAND':
      return { ...state, showAlertMobileLandscape: action.value };
    case 'SESSION_SET_THEME':
      return { ...state, theme: action.theme };
    case 'SESSION_SET_USER': {
      const user = action.user || notLoggedInUser();
      return { ...state, user };
    }
    case 'SESSION_SET_CHAIN_DATA':
      return { ...state, chainData: action.chainData };
    case 'SESSION_SET_SESSION_ID':
      return { ...state, sessionId: action.sessionId };
    case 'SESSION_SET_IS_CREATING_BOOKING':
      return { ...state, isCreatingBooking: action.creatingBooking };
    case 'BOOKING_SET_CALL_CENTER_CUSTOMER_CODE':
      return { ...state, callCenterCustomerCode: action.callCenterCustomerCode };
    case 'BOOKING_SET_OPEN_RESERVATION_DETAILS':
      return { ...state, openReservationDetails: action.openReservationDetails };
    default:
      return state;
  }
};
